<template lang="pug">
	modal(v-if="EmisoraID", :max-width="400")
		.card.text-left
			.card-header
				span.fa.fa-puzzle-piece.mr-2
				| Colocación
				button.close(@click="cerrar") &times;
			.card-body.bg-light.text-center
				// TENEMOS 3 POSIBILIDADES DE COLOCACIÓN:
					- POR PROGRAMA
					- POR CONTENIDOS
					- POR INTÉRVALOS DE HORAS Y DÍAS MANUALES
				.alert.alert-success.text-left
					b
						span.fa.fa-puzzle-piece.mr-2
						| Tipo de colocación
					p
						| Debes definir el tipo de colocación que vas a emplear:
						ul
							li <b>Por programa:</b> Los originales siempre se colocarán dentro del programa seleccionado
							li <b>Por contenido:</b> Los originales siempre se colocación dentro de los contenidos seleccionados
							li <b>Manual:</b> Debes definir un intérvalo de días de la semana y horas para colocar los originales
				.form-group
					label Tipo de colocación
					br
					.btn-group
						button.btn(:class="(tipoColocacion === 'Programa') ? 'btn-primary' : ''", @click="setTipoColocacion('Programa')") Programa
						button.btn(:class="(tipoColocacion === 'Contenido') ? 'btn-primary' : ''", @click="setTipoColocacion('Contenido')") Contenido
						button.btn(:class="(tipoColocacion === 'Manual') ? 'btn-primary' : ''", @click="setTipoColocacion('Manual')") Manual
			SeleccionPrograma(:EmisoraID="EmisoraID", :colocacion.sync="colocacion", v-if="tipoColocacion === 'Programa'")
			SeleccionContenido(:EmisoraID="EmisoraID", :colocacion.sync="colocacion", v-if="tipoColocacion === 'Contenido'")
			ColocacionManual(:colocacion.sync="colocacion", v-if="tipoColocacion === 'Manual'")
			.card-body.bg-light
				span.fa.fa-list.mr-2
				b Fijación
				select.form-control.form-control-sm(v-model="colocacion.Fijar")
					option(:value="null") Aleatorio
					option(v-for="tipo in fijaciones", :value="tipo") {{tipo}}
			.card-footer
				button.btn.btn-sm.btn-primary(@click="confirmar")
					span.fa.fa-check.mr-2
					| Confirmar

</template>

<script>
import SeleccionPrograma from './programa.vue'
import SeleccionContenido from './contenido'
import ColocacionManual from './manual'
export default {
	props: ['EmisoraID', 'datos'],
	components: {
		SeleccionPrograma,
		SeleccionContenido,
		ColocacionManual
	},
	data () {
		return {
			colocacion: {
				ContenidoID: null,
				ContenidoNombre: null,
				ProgramaID: null,
				ProgramaNombre: null,
				Posicion: null,
				Fijar: null,
				HoraInicio: null,
				HoraFin: null
			},
			tipoColocacion: 'Programa',
			fijaciones: [
				'Primera',
				'Segunda',
				'Mitad',
				'Penultima',
				'Ultima'
			]
		}
	},
	created () {
		if (this.datos) {
			this.colocacion = {...this.colocacion, ...this.datos}
		}
	},
	methods: {
		setTipoColocacion (tipo) {
			this.colocacion.ProgramaID = null
			this.colocacion.ProgramaNombre = null
			this.colocacion.ContenidoID = null
			this.colocacion.ContenidoNombre = null
			this.colocacion.HoraInicio = null
			this.colocacion.HoraFin = null
			this.tipoColocacion = tipo
		},
		confirmar () {
			this.$emit('colocacion', this.colocacion)
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/colocacion/colocacion.vue